<ion-content>
  @if (!isDesktop) {
    <ion-refresher mode="ios" slot="fixed" (ionRefresh)="refresh($event)">
      <ion-refresher-content refreshingSpinner="crescent"></ion-refresher-content>
    </ion-refresher>
    @if (show) {
      <ion-item lines="none" color="medium-tint" style="background-color: var(--ion-color-background-pull-to-refresh) !important; cursor: pointer" class="ion-item-min-content-height">
        <ion-row class="ion-justify-content-center ion-full-width ion-align-items-center ion-no-padding">
          <ion-col class="ion-text-align-center ion-col-with-left-and-right-icon">
            <ion-icon name="arrow-down-circle-outline" size="medium" style="color: var(--ion-color-pull-to-refresh)"></ion-icon>
            <ion-text class="ion-font-size-smaller ion-font-style-oblique" style="color: var(--ion-color-pull-to-refresh)" translate>LIVE.PULL_TO_REFRESH</ion-text>
            <ion-icon name="arrow-down-circle-outline"></ion-icon>
          </ion-col>
        </ion-row>
      </ion-item>
    }
  }
  <ng-content></ng-content>
</ion-content>
